// Rejecting a sim stream
import BaseError from './BaseError';

class SimStreamError extends BaseError {
  constructor(message: string, fileName?: string, lineNumber?: number) {
    super('SimStreamError', message, fileName, lineNumber);
  }
}

export default SimStreamError;
